import React, { useMemo, useRef } from 'react';
import cn from 'clsx';
import {
  Button,
  CardMedia,
  LinkWithGAPromoClick,
  MediaCard,
  MediaCardContent,
  SectionSubTitle,
  Swiper,
  SwiperSlide,
  Typography,
} from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils';
import { useStoreon } from 'storeon/react';
import { State } from 'store/types';
import { LANDINGS_STORE_NAME } from 'modules/landings-info';
import {
  bannerBody,
  bannerSingleBody,
  bannerButton,
  bannerCard,
  bannerDescription,
  bannerImage,
  bannerSlide,
  bannerSingleSlide,
  bannerTitle,
  bannersSectionStyles,
} from './banners-section-styles';
import { BANNER_LIST_FULL, BANNER_LIST_SINGLE, BannerStructure } from './banners-section-constants';

/**
 * Вью секции с баннерами
 */
export const BannersSection = () => {
  const { landings } = useStoreon<State>(LANDINGS_STORE_NAME);
  const { landingsList } = landings;
  const bannerRefs = useRef<HTMLAnchorElement[]>([]);

  const finalBannerList = useMemo(
    () => (landingsList && landingsList.length > 0 ? BANNER_LIST_FULL : BANNER_LIST_SINGLE),
    [landingsList]
  );

  const promotions = useMemo(
    () =>
      finalBannerList.map((banner: BannerStructure, index: number) => ({
        name: 'sad_middle_promoBlock',
        creative: `sad_${banner.title}`,
        position: (index + 1).toString(),
      })),
    [finalBannerList]
  );

  usePromoViewEvent(bannerRefs, 'landingSad / promo', promotions);

  return (
    <section className={bannersSectionStyles}>
      <Swiper slidesPerView="auto">
        {finalBannerList.map(({ imgSrc, link, title, description }: BannerStructure, index: number) => (
          <SwiperSlide
            className={cn(bannerSlide, { [bannerSingleSlide]: finalBannerList.length === 1 })}
            key={createElementKey('garden-banner', index)}>
            <LinkWithGAPromoClick
              bannerRefs={bannerRefs}
              elementBlock="landingSad / promo"
              position={index}
              promotion={promotions[index]}
              {...link}>
              <MediaCard className={bannerCard}>
                <CardMedia
                  className={bannerImage}
                  src={imgSrc}
                  title={title}
                  alt={title}
                  width={580}
                  height={264}
                />
                <MediaCardContent
                  className={cn(bannerBody, { [bannerSingleBody]: finalBannerList.length === 1 })}>
                  <div>
                    <SectionSubTitle className={bannerTitle} margin="s">
                      {title}
                    </SectionSubTitle>
                    <Typography className={bannerDescription} variant="m" size="body_short">
                      {description}
                    </Typography>
                  </div>
                  <div>
                    <Button className={bannerButton} variant="secondary">
                      Подробнее
                    </Button>
                  </div>
                </MediaCardContent>
              </MediaCard>
            </LinkWithGAPromoClick>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
